// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__WwcWe","range":"MonthRangeSwitch_range__qdDP9","disabled":"MonthRangeSwitch_disabled__12J4d"};